import appGetters from "./getters.js";
import appMutations from "./mutations.js";

export default {
  namespaced: true,
  state() {
    return {
      appLanguages: [{ name: "English", culture: "en" }],
      chatOptions: [
        { name: "Whats App", value: "WA", icon: "icon-whats-app" },
        { name: "Microsoft Teams", value: "MT", icon: "icon-microsoft-teams" },
        { name: "None", value: "None" },
      ],
      availableRoles: [],
      availableCountries: [{ name: "Australia", value: "AU" }],
      countries: [
        {
          label: "Afghanistan",
          dial: "93",
          value: "AF",
          dialLabel: "+93 (Afghanistan)",
        },
        {
          label: "Albania",
          dial: "355",
          value: "AL",
          dialLabel: "+355 (Albania)",
        },
        {
          label: "Algeria",
          dial: "213",
          value: "DZ",
          dialLabel: "+213 (Algeria)",
        },
        {
          label: "American Samoa",
          dial: "1-684",
          value: "AS",
          dialLabel: "+1-684 (American Samoa)",
        },
        {
          label: "Andorra",
          dial: "376",
          value: "AD",
          dialLabel: "+376 (Andorra)",
        },
        {
          label: "Angola",
          dial: "244",
          value: "AO",
          dialLabel: "+244 (Angola)",
        },
        {
          label: "Anguilla",
          dial: "1-264",
          value: "AI",
          dialLabel: "+1-264 (Anguilla)",
        },
        {
          label: "Antarctica",
          dial: "672",
          value: "AQ",
          dialLabel: "+672 (Antarctica)",
        },
        {
          label: "Antigua and Barbuda",
          dial: "1-268",
          value: "AG",
          dialLabel: "+1-268 (Antigua and Barbuda)",
        },
        {
          label: "Argentina",
          dial: "54",
          value: "AR",
          dialLabel: "+54 (Argentina)",
        },
        {
          label: "Armenia",
          dial: "374",
          value: "AM",
          dialLabel: "+374 (Armenia)",
        },
        { label: "Aruba", dial: "297", value: "AW", dialLabel: "+297 (Aruba)" },
        {
          label: "Australia",
          dial: "61",
          value: "AU",
          dialLabel: "+61 (Australia)",
        },
        {
          label: "Austria",
          dial: "43",
          value: "AT",
          dialLabel: "+43 (Austria)",
        },
        {
          label: "Azerbaijan",
          dial: "994",
          value: "AZ",
          dialLabel: "+994 (Azerbaijan)",
        },
        {
          label: "Bahamas",
          dial: "1-242",
          value: "BS",
          dialLabel: "+1-242 (Bahamas)",
        },
        {
          label: "Bahrain",
          dial: "973",
          value: "BH",
          dialLabel: "+973 (Bahrain)",
        },
        {
          label: "Bangladesh",
          dial: "880",
          value: "BD",
          dialLabel: "+880 (Bangladesh)",
        },
        {
          label: "Barbados",
          dial: "1-246",
          value: "BB",
          dialLabel: "+1-246 (Barbados)",
        },
        {
          label: "Belarus",
          dial: "375",
          value: "BY",
          dialLabel: "+375 (Belarus)",
        },
        {
          label: "Belgium",
          dial: "32",
          value: "BE",
          dialLabel: "+32 (Belgium)",
        },
        {
          label: "Belize",
          dial: "501",
          value: "BZ",
          dialLabel: "+501 (Belize)",
        },
        { label: "Benin", dial: "229", value: "BJ", dialLabel: "+229 (Benin)" },
        {
          label: "Bermuda",
          dial: "1-441",
          value: "BM",
          dialLabel: "+1-441 (Bermuda)",
        },
        {
          label: "Bhutan",
          dial: "975",
          value: "BT",
          dialLabel: "+975 (Bhutan)",
        },
        {
          label: "Bolivia",
          dial: "591",
          value: "BO",
          dialLabel: "+591 (Bolivia)",
        },
        {
          label: "Bosnia and Herzegovina",
          dial: "387",
          value: "BA",
          dialLabel: "+387 (Bosnia and Herzegovina)",
        },
        {
          label: "Botswana",
          dial: "267",
          value: "BW",
          dialLabel: "+267 (Botswana)",
        },
        { label: "Brazil", dial: "55", value: "BR", dialLabel: "+55 (Brazil)" },
        {
          label: "British Indian Ocean Territory",
          dial: "246",
          value: "IO",
          dialLabel: "+246 (British Indian Ocean Territory)",
        },
        {
          label: "British Virgin Islands",
          dial: "1-284",
          value: "VG",
          dialLabel: "+1-284 (British Virgin Islands)",
        },
        {
          label: "Brunei",
          dial: "673",
          value: "BN",
          dialLabel: "+673 (Brunei)",
        },
        {
          label: "Bulgaria",
          dial: "359",
          value: "BG",
          dialLabel: "+359 (Bulgaria)",
        },
        {
          label: "Burkina Faso",
          dial: "226",
          value: "BF",
          dialLabel: "+226 (Burkina Faso)",
        },
        {
          label: "Burundi",
          dial: "257",
          value: "BI",
          dialLabel: "+257 (Burundi)",
        },
        {
          label: "Cambodia",
          dial: "855",
          value: "KH",
          dialLabel: "+855 (Cambodia)",
        },
        {
          label: "Cameroon",
          dial: "237",
          value: "CM",
          dialLabel: "+237 (Cameroon)",
        },
        { label: "Canada", dial: "1", value: "CA", dialLabel: "+1 (Canada)" },
        {
          label: "Cape Verde",
          dial: "238",
          value: "CV",
          dialLabel: "+238 (Cape Verde)",
        },
        {
          label: "Cayman Islands",
          dial: "1-345",
          value: "KY",
          dialLabel: "+1-345 (Cayman Islands)",
        },
        {
          label: "Central African Republic",
          dial: "236",
          value: "CF",
          dialLabel: "+236 (Central African Republic)",
        },
        { label: "Chad", dial: "235", value: "TD", dialLabel: "+235 (Chad)" },
        { label: "Chile", dial: "56", value: "CL", dialLabel: "+56 (Chile)" },
        { label: "China", dial: "86", value: "CN", dialLabel: "+86 (China)" },
        {
          label: "Christmas Island",
          dial: "61",
          value: "CX",
          dialLabel: "+61 (Christmas Island)",
        },
        {
          label: "Cocos Islands",
          dial: "61",
          value: "CC",
          dialLabel: "+61 (Cocos Islands)",
        },
        {
          label: "Colombia",
          dial: "57",
          value: "CO",
          dialLabel: "+57 (Colombia)",
        },
        {
          label: "Comoros",
          dial: "269",
          value: "KM",
          dialLabel: "+269 (Comoros)",
        },
        {
          label: "Cook Islands",
          dial: "682",
          value: "CK",
          dialLabel: "+682 (Cook Islands)",
        },
        {
          label: "Costa Rica",
          dial: "506",
          value: "CR",
          dialLabel: "+506 (Costa Rica)",
        },
        {
          label: "Croatia",
          dial: "385",
          value: "HR",
          dialLabel: "+385 (Croatia)",
        },
        { label: "Cuba", dial: "53", value: "CU", dialLabel: "+53 (Cuba)" },
        {
          label: "Curacao",
          dial: "599",
          value: "CW",
          dialLabel: "+599 (Curacao)",
        },
        {
          label: "Cyprus",
          dial: "357",
          value: "CY",
          dialLabel: "+357 (Cyprus)",
        },
        {
          label: "Czech Republic",
          dial: "420",
          value: "CZ",
          dialLabel: "+420 (Czech Republic)",
        },
        {
          label: "Democratic Republic of the Congo",
          dial: "243",
          value: "CD",
          dialLabel: "+243 (Democratic Republic of the Congo)",
        },
        {
          label: "Denmark",
          dial: "45",
          value: "DK",
          dialLabel: "+45 (Denmark)",
        },
        {
          label: "Djibouti",
          dial: "253",
          value: "DJ",
          dialLabel: "+253 (Djibouti)",
        },
        {
          label: "Dominica",
          dial: "1-767",
          value: "DM",
          dialLabel: "+1-767 (Dominica)",
        },
        {
          label: "Dominican Republic",
          dial: "1-809, 1-829, 1-849",
          value: "DO",
          dialLabel: "+1-809, 1-829, 1-849 (Dominican Republic)",
        },
        {
          label: "East Timor",
          dial: "670",
          value: "TL",
          dialLabel: "+670 (East Timor)",
        },
        {
          label: "Ecuador",
          dial: "593",
          value: "EC",
          dialLabel: "+593 (Ecuador)",
        },
        { label: "Egypt", dial: "20", value: "EG", dialLabel: "+20 (Egypt)" },
        {
          label: "El Salvador",
          dial: "503",
          value: "SV",
          dialLabel: "+503 (El Salvador)",
        },
        {
          label: "Equatorial Guinea",
          dial: "240",
          value: "GQ",
          dialLabel: "+240 (Equatorial Guinea)",
        },
        {
          label: "Eritrea",
          dial: "291",
          value: "ER",
          dialLabel: "+291 (Eritrea)",
        },
        {
          label: "Estonia",
          dial: "372",
          value: "EE",
          dialLabel: "+372 (Estonia)",
        },
        {
          label: "Ethiopia",
          dial: "251",
          value: "ET",
          dialLabel: "+251 (Ethiopia)",
        },
        {
          label: "Falkland Islands",
          dial: "500",
          value: "FK",
          dialLabel: "+500 (Falkland Islands)",
        },
        {
          label: "Faroe Islands",
          dial: "298",
          value: "FO",
          dialLabel: "+298 (Faroe Islands)",
        },
        { label: "Fiji", dial: "679", value: "FJ", dialLabel: "+679 (Fiji)" },
        {
          label: "Finland",
          dial: "358",
          value: "FI",
          dialLabel: "+358 (Finland)",
        },
        { label: "France", dial: "33", value: "FR", dialLabel: "+33 (France)" },
        {
          label: "French Polynesia",
          dial: "689",
          value: "PF",
          dialLabel: "+689 (French Polynesia)",
        },
        { label: "Gabon", dial: "241", value: "GA", dialLabel: "+241 (Gabon)" },
        {
          label: "Gambia",
          dial: "220",
          value: "GM",
          dialLabel: "+220 (Gambia)",
        },
        {
          label: "Georgia",
          dial: "995",
          value: "GE",
          dialLabel: "+995 (Georgia)",
        },
        {
          label: "Germany",
          dial: "49",
          value: "DE",
          dialLabel: "+49 (Germany)",
        },
        { label: "Ghana", dial: "233", value: "GH", dialLabel: "+233 (Ghana)" },
        {
          label: "Gibraltar",
          dial: "350",
          value: "GI",
          dialLabel: "+350 (Gibraltar)",
        },
        { label: "Greece", dial: "30", value: "GR", dialLabel: "+30 (Greece)" },
        {
          label: "Greenland",
          dial: "299",
          value: "GL",
          dialLabel: "+299 (Greenland)",
        },
        {
          label: "Grenada",
          dial: "1-473",
          value: "GD",
          dialLabel: "+1-473 (Grenada)",
        },
        {
          label: "Guam",
          dial: "1-671",
          value: "GU",
          dialLabel: "+1-671 (Guam)",
        },
        {
          label: "Guatemala",
          dial: "502",
          value: "GT",
          dialLabel: "+502 (Guatemala)",
        },
        {
          label: "Guernsey",
          dial: "44-1481",
          value: "GG",
          dialLabel: "+44-1481 (Guernsey)",
        },
        {
          label: "Guinea",
          dial: "224",
          value: "GN",
          dialLabel: "+224 (Guinea)",
        },
        {
          label: "Guinea-Bissau",
          dial: "245",
          value: "GW",
          dialLabel: "+245 (Guinea-Bissau)",
        },
        {
          label: "Guyana",
          dial: "592",
          value: "GY",
          dialLabel: "+592 (Guyana)",
        },
        { label: "Haiti", dial: "509", value: "HT", dialLabel: "+509 (Haiti)" },
        {
          label: "Honduras",
          dial: "504",
          value: "HN",
          dialLabel: "+504 (Honduras)",
        },
        {
          label: "Hong Kong",
          dial: "852",
          value: "HK",
          dialLabel: "+852 (Hong Kong)",
        },
        {
          label: "Hungary",
          dial: "36",
          value: "HU",
          dialLabel: "+36 (Hungary)",
        },
        {
          label: "Iceland",
          dial: "354",
          value: "IS",
          dialLabel: "+354 (Iceland)",
        },
        { label: "India", dial: "91", value: "IN", dialLabel: "+91 (India)" },
        {
          label: "Indonesia",
          dial: "62",
          value: "ID",
          dialLabel: "+62 (Indonesia)",
        },
        { label: "Iran", dial: "98", value: "IR", dialLabel: "+98 (Iran)" },
        { label: "Iraq", dial: "964", value: "IQ", dialLabel: "+964 (Iraq)" },
        {
          label: "Ireland",
          dial: "353",
          value: "IE",
          dialLabel: "+353 (Ireland)",
        },
        {
          label: "Isle of Man",
          dial: "44-1624",
          value: "IM",
          dialLabel: "+44-1624 (Isle of Man)",
        },
        {
          label: "Israel",
          dial: "972",
          value: "IL",
          dialLabel: "+972 (Israel)",
        },
        { label: "Italy", dial: "39", value: "IT", dialLabel: "+39 (Italy)" },
        {
          label: "Ivory Coast",
          dial: "225",
          value: "CI",
          dialLabel: "+225 (Ivory Coast)",
        },
        {
          label: "Jamaica",
          dial: "1-876",
          value: "JM",
          dialLabel: "+1-876 (Jamaica)",
        },
        { label: "Japan", dial: "81", value: "JP", dialLabel: "+81 (Japan)" },
        {
          label: "Jersey",
          dial: "44-1534",
          value: "JE",
          dialLabel: "+44-1534 (Jersey)",
        },
        {
          label: "Jordan",
          dial: "962",
          value: "JO",
          dialLabel: "+962 (Jordan)",
        },
        {
          label: "Kazakhstan",
          dial: "7",
          value: "KZ",
          dialLabel: "+7 (Kazakhstan)",
        },
        { label: "Kenya", dial: "254", value: "KE", dialLabel: "+254 (Kenya)" },
        {
          label: "Kiribati",
          dial: "686",
          value: "KI",
          dialLabel: "+686 (Kiribati)",
        },
        {
          label: "Kosovo",
          dial: "383",
          value: "XK",
          dialLabel: "+383 (Kosovo)",
        },
        {
          label: "Kuwait",
          dial: "965",
          value: "KW",
          dialLabel: "+965 (Kuwait)",
        },
        {
          label: "Kyrgyzstan",
          dial: "996",
          value: "KG",
          dialLabel: "+996 (Kyrgyzstan)",
        },
        { label: "Laos", dial: "856", value: "LA", dialLabel: "+856 (Laos)" },
        {
          label: "Latvia",
          dial: "371",
          value: "LV",
          dialLabel: "+371 (Latvia)",
        },
        {
          label: "Lebanon",
          dial: "961",
          value: "LB",
          dialLabel: "+961 (Lebanon)",
        },
        {
          label: "Lesotho",
          dial: "266",
          value: "LS",
          dialLabel: "+266 (Lesotho)",
        },
        {
          label: "Liberia",
          dial: "231",
          value: "LR",
          dialLabel: "+231 (Liberia)",
        },
        { label: "Libya", dial: "218", value: "LY", dialLabel: "+218 (Libya)" },
        {
          label: "Liechtenstein",
          dial: "423",
          value: "LI",
          dialLabel: "+423 (Liechtenstein)",
        },
        {
          label: "Lithuania",
          dial: "370",
          value: "LT",
          dialLabel: "+370 (Lithuania)",
        },
        {
          label: "Luxembourg",
          dial: "352",
          value: "LU",
          dialLabel: "+352 (Luxembourg)",
        },
        { label: "Macao", dial: "853", value: "MO", dialLabel: "+853 (Macao)" },
        {
          label: "Macedonia",
          dial: "389",
          value: "MK",
          dialLabel: "+389 (Macedonia)",
        },
        {
          label: "Madagascar",
          dial: "261",
          value: "MG",
          dialLabel: "+261 (Madagascar)",
        },
        {
          label: "Malawi",
          dial: "265",
          value: "MW",
          dialLabel: "+265 (Malawi)",
        },
        {
          label: "Malaysia",
          dial: "60",
          value: "MY",
          dialLabel: "+60 (Malaysia)",
        },
        {
          label: "Maldives",
          dial: "960",
          value: "MV",
          dialLabel: "+960 (Maldives)",
        },
        { label: "Mali", dial: "223", value: "ML", dialLabel: "+223 (Mali)" },
        { label: "Malta", dial: "356", value: "MT", dialLabel: "+356 (Malta)" },
        {
          label: "Marshall Islands",
          dial: "692",
          value: "MH",
          dialLabel: "+692 (Marshall Islands)",
        },
        {
          label: "Mauritania",
          dial: "222",
          value: "MR",
          dialLabel: "+222 (Mauritania)",
        },
        {
          label: "Mauritius",
          dial: "230",
          value: "MU",
          dialLabel: "+230 (Mauritius)",
        },
        {
          label: "Mayotte",
          dial: "262",
          value: "YT",
          dialLabel: "+262 (Mayotte)",
        },
        { label: "Mexico", dial: "52", value: "MX", dialLabel: "+52 (Mexico)" },
        {
          label: "Micronesia",
          dial: "691",
          value: "FM",
          dialLabel: "+691 (Micronesia)",
        },
        {
          label: "Moldova",
          dial: "373",
          value: "MD",
          dialLabel: "+373 (Moldova)",
        },
        {
          label: "Monaco",
          dial: "377",
          value: "MC",
          dialLabel: "+377 (Monaco)",
        },
        {
          label: "Mongolia",
          dial: "976",
          value: "MN",
          dialLabel: "+976 (Mongolia)",
        },
        {
          label: "Montenegro",
          dial: "382",
          value: "ME",
          dialLabel: "+382 (Montenegro)",
        },
        {
          label: "Montserrat",
          dial: "1-664",
          value: "MS",
          dialLabel: "+1-664 (Montserrat)",
        },
        {
          label: "Morocco",
          dial: "212",
          value: "MA",
          dialLabel: "+212 (Morocco)",
        },
        {
          label: "Mozambique",
          dial: "258",
          value: "MZ",
          dialLabel: "+258 (Mozambique)",
        },
        {
          label: "Myanmar",
          dial: "95",
          value: "MM",
          dialLabel: "+95 (Myanmar)",
        },
        {
          label: "Namibia",
          dial: "264",
          value: "NA",
          dialLabel: "+264 (Namibia)",
        },
        { label: "Nauru", dial: "674", value: "NR", dialLabel: "+674 (Nauru)" },
        { label: "Nepal", dial: "977", value: "NP", dialLabel: "+977 (Nepal)" },
        {
          label: "Netherlands",
          dial: "31",
          value: "NL",
          dialLabel: "+31 (Netherlands)",
        },
        {
          label: "Netherlands Antilles",
          dial: "599",
          value: "AN",
          dialLabel: "+599 (Netherlands Antilles)",
        },
        {
          label: "New Caledonia",
          dial: "687",
          value: "NC",
          dialLabel: "+687 (New Caledonia)",
        },
        {
          label: "New Zealand",
          dial: "64",
          value: "NZ",
          dialLabel: "+64 (New Zealand)",
        },
        {
          label: "Nicaragua",
          dial: "505",
          value: "NI",
          dialLabel: "+505 (Nicaragua)",
        },
        { label: "Niger", dial: "227", value: "NE", dialLabel: "+227 (Niger)" },
        {
          label: "Nigeria",
          dial: "234",
          value: "NG",
          dialLabel: "+234 (Nigeria)",
        },
        { label: "Niue", dial: "683", value: "NU", dialLabel: "+683 (Niue)" },
        {
          label: "North Korea",
          dial: "850",
          value: "KP",
          dialLabel: "+850 (North Korea)",
        },
        {
          label: "Northern Mariana Islands",
          dial: "1-670",
          value: "MP",
          dialLabel: "+1-670 (Northern Mariana Islands)",
        },
        { label: "Norway", dial: "47", value: "NO", dialLabel: "+47 (Norway)" },
        { label: "Oman", dial: "968", value: "OM", dialLabel: "+968 (Oman)" },
        {
          label: "Pakistan",
          dial: "92",
          value: "PK",
          dialLabel: "+92 (Pakistan)",
        },
        { label: "Palau", dial: "680", value: "PW", dialLabel: "+680 (Palau)" },
        {
          label: "Palestine",
          dial: "970",
          value: "PS",
          dialLabel: "+970 (Palestine)",
        },
        {
          label: "Panama",
          dial: "507",
          value: "PA",
          dialLabel: "+507 (Panama)",
        },
        {
          label: "Papua New Guinea",
          dial: "675",
          value: "PG",
          dialLabel: "+675 (Papua New Guinea)",
        },
        {
          label: "Paraguay",
          dial: "595",
          value: "PY",
          dialLabel: "+595 (Paraguay)",
        },
        { label: "Peru", dial: "51", value: "PE", dialLabel: "+51 (Peru)" },
        {
          label: "Philippines",
          dial: "63",
          value: "PH",
          dialLabel: "+63 (Philippines)",
        },
        {
          label: "Pitcairn",
          dial: "64",
          value: "PN",
          dialLabel: "+64 (Pitcairn)",
        },
        { label: "Poland", dial: "48", value: "PL", dialLabel: "+48 (Poland)" },
        {
          label: "Portugal",
          dial: "351",
          value: "PT",
          dialLabel: "+351 (Portugal)",
        },
        {
          label: "Puerto Rico",
          dial: "1-787, 1-939",
          value: "PR",
          dialLabel: "+1-787, 1-939 (Puerto Rico)",
        },
        { label: "Qatar", dial: "974", value: "QA", dialLabel: "+974 (Qatar)" },
        {
          label: "Republic of the Congo",
          dial: "242",
          value: "CG",
          dialLabel: "+242 (Republic of the Congo)",
        },
        {
          label: "Reunion",
          dial: "262",
          value: "RE",
          dialLabel: "+262 (Reunion)",
        },
        {
          label: "Romania",
          dial: "40",
          value: "RO",
          dialLabel: "+40 (Romania)",
        },
        { label: "Russia", dial: "7", value: "RU", dialLabel: "+7 (Russia)" },
        {
          label: "Rwanda",
          dial: "250",
          value: "RW",
          dialLabel: "+250 (Rwanda)",
        },
        {
          label: "Saint Barthelemy",
          dial: "590",
          value: "BL",
          dialLabel: "+590 (Saint Barthelemy)",
        },
        {
          label: "Saint Helena",
          dial: "290",
          value: "SH",
          dialLabel: "+290 (Saint Helena)",
        },
        {
          label: "Saint Kitts and Nevis",
          dial: "1-869",
          value: "KN",
          dialLabel: "+1-869 (Saint Kitts and Nevis)",
        },
        {
          label: "Saint Lucia",
          dial: "1-758",
          value: "LC",
          dialLabel: "+1-758 (Saint Lucia)",
        },
        {
          label: "Saint Martin",
          dial: "590",
          value: "MF",
          dialLabel: "+590 (Saint Martin)",
        },
        {
          label: "Saint Pierre and Miquelon",
          dial: "508",
          value: "PM",
          dialLabel: "+508 (Saint Pierre and Miquelon)",
        },
        {
          label: "Saint Vincent and the Grenadines",
          dial: "1-784",
          value: "VC",
          dialLabel: "+1-784 (Saint Vincent and the Grenadines)",
        },
        { label: "Samoa", dial: "685", value: "WS", dialLabel: "+685 (Samoa)" },
        {
          label: "San Marino",
          dial: "378",
          value: "SM",
          dialLabel: "+378 (San Marino)",
        },
        {
          label: "Sao Tome and Principe",
          dial: "239",
          value: "ST",
          dialLabel: "+239 (Sao Tome and Principe)",
        },
        {
          label: "Saudi Arabia",
          dial: "966",
          value: "SA",
          dialLabel: "+966 (Saudi Arabia)",
        },
        {
          label: "Senegal",
          dial: "221",
          value: "SN",
          dialLabel: "+221 (Senegal)",
        },
        {
          label: "Serbia",
          dial: "381",
          value: "RS",
          dialLabel: "+381 (Serbia)",
        },
        {
          label: "Seychelles",
          dial: "248",
          value: "SC",
          dialLabel: "+248 (Seychelles)",
        },
        {
          label: "Sierra Leone",
          dial: "232",
          value: "SL",
          dialLabel: "+232 (Sierra Leone)",
        },
        {
          label: "Singapore",
          dial: "65",
          value: "SG",
          dialLabel: "+65 (Singapore)",
        },
        {
          label: "Sint Maarten",
          dial: "1-721",
          value: "SX",
          dialLabel: "+1-721 (Sint Maarten)",
        },
        {
          label: "Slovakia",
          dial: "421",
          value: "SK",
          dialLabel: "+421 (Slovakia)",
        },
        {
          label: "Slovenia",
          dial: "386",
          value: "SI",
          dialLabel: "+386 (Slovenia)",
        },
        {
          label: "Solomon Islands",
          dial: "677",
          value: "SB",
          dialLabel: "+677 (Solomon Islands)",
        },
        {
          label: "Somalia",
          dial: "252",
          value: "SO",
          dialLabel: "+252 (Somalia)",
        },
        {
          label: "South Africa",
          dial: "27",
          value: "ZA",
          dialLabel: "+27 (South Africa)",
        },
        {
          label: "South Korea",
          dial: "82",
          value: "KR",
          dialLabel: "+82 (South Korea)",
        },
        {
          label: "South Sudan",
          dial: "211",
          value: "SS",
          dialLabel: "+211 (South Sudan)",
        },
        { label: "Spain", dial: "34", value: "ES", dialLabel: "+34 (Spain)" },
        {
          label: "Sri Lanka",
          dial: "94",
          value: "LK",
          dialLabel: "+94 (Sri Lanka)",
        },
        { label: "Sudan", dial: "249", value: "SD", dialLabel: "+249 (Sudan)" },
        {
          label: "Suriname",
          dial: "597",
          value: "SR",
          dialLabel: "+597 (Suriname)",
        },
        {
          label: "Svalbard and Jan Mayen",
          dial: "47",
          value: "SJ",
          dialLabel: "+47 (Svalbard and Jan Mayen)",
        },
        {
          label: "Swaziland",
          dial: "268",
          value: "SZ",
          dialLabel: "+268 (Swaziland)",
        },
        { label: "Sweden", dial: "46", value: "SE", dialLabel: "+46 (Sweden)" },
        {
          label: "Switzerland",
          dial: "41",
          value: "CH",
          dialLabel: "+41 (Switzerland)",
        },
        { label: "Syria", dial: "963", value: "SY", dialLabel: "+963 (Syria)" },
        {
          label: "Taiwan",
          dial: "886",
          value: "TW",
          dialLabel: "+886 (Taiwan)",
        },
        {
          label: "Tajikistan",
          dial: "992",
          value: "TJ",
          dialLabel: "+992 (Tajikistan)",
        },
        {
          label: "Tanzania",
          dial: "255",
          value: "TZ",
          dialLabel: "+255 (Tanzania)",
        },
        {
          label: "Thailand",
          dial: "66",
          value: "TH",
          dialLabel: "+66 (Thailand)",
        },
        { label: "Togo", dial: "228", value: "TG", dialLabel: "+228 (Togo)" },
        {
          label: "Tokelau",
          dial: "690",
          value: "TK",
          dialLabel: "+690 (Tokelau)",
        },
        { label: "Tonga", dial: "676", value: "TO", dialLabel: "+676 (Tonga)" },
        {
          label: "Trinidad and Tobago",
          dial: "1-868",
          value: "TT",
          dialLabel: "+1-868 (Trinidad and Tobago)",
        },
        {
          label: "Tunisia",
          dial: "216",
          value: "TN",
          dialLabel: "+216 (Tunisia)",
        },
        { label: "Turkey", dial: "90", value: "TR", dialLabel: "+90 (Turkey)" },
        {
          label: "Turkmenistan",
          dial: "993",
          value: "TM",
          dialLabel: "+993 (Turkmenistan)",
        },
        {
          label: "Turks and Caicos Islands",
          dial: "1-649",
          value: "TC",
          dialLabel: "+1-649 (Turks and Caicos Islands)",
        },
        {
          label: "Tuvalu",
          dial: "688",
          value: "TV",
          dialLabel: "+688 (Tuvalu)",
        },
        {
          label: "U.S. Virgin Islands",
          dial: "1-340",
          value: "VI",
          dialLabel: "+1-340 (U.S. Virgin Islands)",
        },
        {
          label: "Uganda",
          dial: "256",
          value: "UG",
          dialLabel: "+256 (Uganda)",
        },
        {
          label: "Ukraine",
          dial: "380",
          value: "UA",
          dialLabel: "+380 (Ukraine)",
        },
        {
          label: "United Arab Emirates",
          dial: "971",
          value: "AE",
          dialLabel: "+971 (United Arab Emirates)",
        },
        {
          label: "United Kingdom",
          dial: "44",
          value: "GB",
          dialLabel: "+44 (United Kingdom)",
        },
        {
          label: "United States",
          dial: "1",
          value: "US",
          dialLabel: "+1 (United States)",
        },
        {
          label: "Uruguay",
          dial: "598",
          value: "UY",
          dialLabel: "+598 (Uruguay)",
        },
        {
          label: "Uzbekistan",
          dial: "998",
          value: "UZ",
          dialLabel: "+998 (Uzbekistan)",
        },
        {
          label: "Vanuatu",
          dial: "678",
          value: "VU",
          dialLabel: "+678 (Vanuatu)",
        },
        {
          label: "Vatican",
          dial: "379",
          value: "VA",
          dialLabel: "+379 (Vatican)",
        },
        {
          label: "Venezuela",
          dial: "58",
          value: "VE",
          dialLabel: "+58 (Venezuela)",
        },
        {
          label: "Vietnam",
          dial: "84",
          value: "VN",
          dialLabel: "+84 (Vietnam)",
        },
        {
          label: "Wallis and Futuna",
          dial: "681",
          value: "WF",
          dialLabel: "+681 (Wallis and Futuna)",
        },
        {
          label: "Western Sahara",
          dial: "212",
          value: "EH",
          dialLabel: "+212 (Western Sahara)",
        },
        { label: "Yemen", dial: "967", value: "YE", dialLabel: "+967 (Yemen)" },
        {
          label: "Zambia",
          dial: "260",
          value: "ZM",
          dialLabel: "+260 (Zambia)",
        },
        {
          label: "Zimbabwe",
          dial: "263",
          value: "ZW",
          dialLabel: "+263 (Zimbabwe)",
        },
      ],
      timeOptions: [
        { name: "12:00 AM", HH: "00", mm: "00" },
        { name: "12:15 AM", HH: "00", mm: "15" },
        { name: "12:30 AM", HH: "00", mm: "30" },
        { name: "12:45 AM", HH: "00", mm: "45" },
        { name: "1:00 AM", HH: "01", mm: "00" },
        { name: "1:15 AM", HH: "01", mm: "15" },
        { name: "1:30 AM", HH: "01", mm: "30" },
        { name: "1:45 AM", HH: "01", mm: "45" },
        { name: "2:00 AM", HH: "02", mm: "00" },
        { name: "2:15 AM", HH: "02", mm: "15" },
        { name: "2:30 AM", HH: "02", mm: "30" },
        { name: "2:45 AM", HH: "02", mm: "45" },
        { name: "3:00 AM", HH: "03", mm: "00" },
        { name: "3:15 AM", HH: "03", mm: "15" },
        { name: "3:30 AM", HH: "03", mm: "30" },
        { name: "3:45 AM", HH: "03", mm: "45" },
        { name: "4:00 AM", HH: "04", mm: "00" },
        { name: "4:15 AM", HH: "04", mm: "15" },
        { name: "4:30 AM", HH: "04", mm: "30" },
        { name: "4:45 AM", HH: "04", mm: "45" },
        { name: "5:00 AM", HH: "05", mm: "00" },
        { name: "5:15 AM", HH: "05", mm: "15" },
        { name: "5:30 AM", HH: "05", mm: "30" },
        { name: "5:45 AM", HH: "05", mm: "45" },
        { name: "6:00 AM", HH: "06", mm: "00" },
        { name: "6:15 AM", HH: "06", mm: "15" },
        { name: "6:30 AM", HH: "06", mm: "30" },
        { name: "6:45 AM", HH: "06", mm: "45" },
        { name: "7:00 AM", HH: "07", mm: "00" },
        { name: "7:15 AM", HH: "07", mm: "15" },
        { name: "7:30 AM", HH: "07", mm: "30" },
        { name: "7:45 AM", HH: "07", mm: "45" },
        { name: "8:00 AM", HH: "08", mm: "00" },
        { name: "8:15 AM", HH: "08", mm: "15" },
        { name: "8:30 AM", HH: "08", mm: "30" },
        { name: "8:45 AM", HH: "08", mm: "45" },
        { name: "9:00 AM", HH: "09", mm: "00" },
        { name: "9:15 AM", HH: "09", mm: "15" },
        { name: "9:30 AM", HH: "09", mm: "30" },
        { name: "9:45 AM", HH: "09", mm: "45" },
        { name: "10:00 AM", HH: "10", mm: "00" },
        { name: "10:15 AM", HH: "10", mm: "15" },
        { name: "10:30 AM", HH: "10", mm: "30" },
        { name: "10:45 AM", HH: "10", mm: "45" },
        { name: "11:00 AM", HH: "11", mm: "00" },
        { name: "11:15 AM", HH: "11", mm: "15" },
        { name: "11:30 AM", HH: "11", mm: "30" },
        { name: "11:45 AM", HH: "11", mm: "45" },
        { name: "12:00 PM", HH: "12", mm: "00" },
        { name: "12:15 PM", HH: "12", mm: "15" },
        { name: "12:30 PM", HH: "12", mm: "30" },
        { name: "12:45 PM", HH: "12", mm: "45" },
        { name: "1:00 PM", HH: "13", mm: "00" },
        { name: "1:15 PM", HH: "13", mm: "15" },
        { name: "1:30 PM", HH: "13", mm: "30" },
        { name: "1:45 PM", HH: "13", mm: "45" },
        { name: "2:00 PM", HH: "14", mm: "00" },
        { name: "2:15 PM", HH: "14", mm: "15" },
        { name: "2:30 PM", HH: "14", mm: "30" },
        { name: "2:45 PM", HH: "14", mm: "45" },
        { name: "3:00 PM", HH: "15", mm: "00" },
        { name: "3:15 PM", HH: "15", mm: "15" },
        { name: "3:30 PM", HH: "15", mm: "30" },
        { name: "3:45 PM", HH: "15", mm: "45" },
        { name: "4:00 PM", HH: "16", mm: "00" },
        { name: "4:15 PM", HH: "16", mm: "15" },
        { name: "4:30 PM", HH: "16", mm: "30" },
        { name: "4:45 PM", HH: "16", mm: "45" },
        { name: "5:00 PM", HH: "17", mm: "00" },
        { name: "5:15 PM", HH: "17", mm: "15" },
        { name: "5:30 PM", HH: "17", mm: "30" },
        { name: "5:45 PM", HH: "17", mm: "45" },
        { name: "6:00 PM", HH: "18", mm: "00" },
        { name: "6:15 PM", HH: "18", mm: "15" },
        { name: "6:30 PM", HH: "18", mm: "30" },
        { name: "6:45 PM", HH: "18", mm: "45" },
        { name: "7:00 PM", HH: "19", mm: "00" },
        { name: "7:15 PM", HH: "19", mm: "15" },
        { name: "7:30 PM", HH: "19", mm: "30" },
        { name: "7:45 PM", HH: "19", mm: "45" },
        { name: "8:00 PM", HH: "20", mm: "00" },
        { name: "8:15 PM", HH: "20", mm: "15" },
        { name: "8:30 PM", HH: "20", mm: "30" },
        { name: "8:45 PM", HH: "20", mm: "45" },
        { name: "9:00 PM", HH: "21", mm: "00" },
        { name: "9:15 PM", HH: "21", mm: "15" },
        { name: "9:30 PM", HH: "21", mm: "30" },
        { name: "9:45 PM", HH: "21", mm: "45" },
        { name: "10:00 PM", HH: "22", mm: "00" },
        { name: "10:15 PM", HH: "22", mm: "15" },
        { name: "10:30 PM", HH: "22", mm: "30" },
        { name: "10:45 PM", HH: "22", mm: "45" },
        { name: "11:00 PM", HH: "23", mm: "00" },
        { name: "11:15 PM", HH: "23", mm: "15" },
        { name: "11:30 PM", HH: "23", mm: "30" },
        { name: "11:45 PM", HH: "23", mm: "45" },
      ],
      timezones: [
        {
          value: "Dateline Standard Time",
          abbr: "DST",
          text: "(UTC-12:00) International Date Line West",
        },
        {
          value: "UTC-11",
          abbr: "U",
          text: "(UTC-11:00) Coordinated Universal Time-11",
        },
        {
          value: "Hawaiian Standard Time",
          abbr: "HST",
          text: "(UTC-10:00) Hawaii",
        },
        {
          value: "Alaskan Standard Time",
          abbr: "AKDT",
          text: "(UTC-09:00) Alaska",
        },
        {
          value: "Pacific Standard Time (Mexico)",
          abbr: "PDT",
          text: "(UTC-08:00) Baja California",
        },
        {
          value: "Pacific Daylight Time",
          abbr: "PDT",
          text: "(UTC-07:00) Pacific Time (US & Canada)",
        },
        {
          value: "Pacific Standard Time",
          abbr: "PST",
          text: "(UTC-08:00) Pacific Time (US & Canada)",
        },
        {
          value: "US Mountain Standard Time",
          abbr: "UMST",
          text: "(UTC-07:00) Arizona",
        },
        {
          value: "Mountain Standard Time (Mexico)",
          abbr: "MDT",
          text: "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
        },
        {
          value: "Mountain Standard Time",
          abbr: "MDT",
          text: "(UTC-07:00) Mountain Time (US & Canada)",
        },
        {
          value: "Central America Standard Time",
          abbr: "CAST",
          text: "(UTC-06:00) Central America",
        },
        {
          value: "Central Standard Time",
          abbr: "CDT",
          text: "(UTC-06:00) Central Time (US & Canada)",
        },
        {
          value: "Central Standard Time (Mexico)",
          abbr: "CDT",
          text: "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
        },
        {
          value: "Canada Central Standard Time",
          abbr: "CCST",
          text: "(UTC-06:00) Saskatchewan",
        },
        {
          value: "SA Pacific Standard Time",
          abbr: "SPST",
          text: "(UTC-05:00) Bogota, Lima, Quito",
        },
        {
          value: "Eastern Standard Time",
          abbr: "EDT",
          text: "(UTC-05:00) Eastern Time (US & Canada)",
        },
        {
          value: "US Eastern Standard Time",
          abbr: "UEDT",
          text: "(UTC-05:00) Indiana (East)",
        },
        {
          value: "Venezuela Standard Time",
          abbr: "VST",
          text: "(UTC-04:30) Caracas",
        },
        {
          value: "Paraguay Standard Time",
          abbr: "PYT",
          text: "(UTC-04:00) Asuncion",
        },
        {
          value: "Atlantic Standard Time",
          abbr: "ADT",
          text: "(UTC-04:00) Atlantic Time (Canada)",
        },
        {
          value: "Central Brazilian Standard Time",
          abbr: "CBST",
          text: "(UTC-04:00) Cuiaba",
        },
        {
          value: "SA Western Standard Time",
          abbr: "SWST",
          text: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
        },
        {
          value: "Pacific SA Standard Time",
          abbr: "PSST",
          text: "(UTC-04:00) Santiago",
        },
        {
          value: "Newfoundland Standard Time",
          abbr: "NDT",
          text: "(UTC-03:30) Newfoundland",
        },
        {
          value: "E. South America Standard Time",
          abbr: "ESAST",
          text: "(UTC-03:00) Brasilia",
        },
        {
          value: "Argentina Standard Time",
          abbr: "AST",
          text: "(UTC-03:00) Buenos Aires",
        },
        {
          value: "SA Eastern Standard Time",
          abbr: "SEST",
          text: "(UTC-03:00) Cayenne, Fortaleza",
        },
        {
          value: "Greenland Standard Time",
          abbr: "GDT",
          text: "(UTC-03:00) Greenland",
        },
        {
          value: "Montevideo Standard Time",
          abbr: "MST",
          text: "(UTC-03:00) Montevideo",
        },
        {
          value: "Bahia Standard Time",
          abbr: "BST",
          text: "(UTC-03:00) Salvador",
        },
        {
          value: "UTC-02",
          abbr: "U",
          text: "(UTC-02:00) Coordinated Universal Time-02",
        },
        {
          value: "Mid-Atlantic Standard Time",
          abbr: "MDT",
          text: "(UTC-02:00) Mid-Atlantic - Old",
        },
        {
          value: "Azores Standard Time",
          abbr: "ADT",
          text: "(UTC-01:00) Azores",
        },
        {
          value: "Cape Verde Standard Time",
          abbr: "CVST",
          text: "(UTC-01:00) Cape Verde Is.",
        },
        {
          value: "Morocco Standard Time",
          abbr: "MDT",
          text: "(UTC) Casablanca",
        },
        {
          value: "UTC",
          abbr: "UTC",
          text: "(UTC) Coordinated Universal Time",
        },
        {
          value: "GMT Standard Time",
          abbr: "GMT",
          text: "(UTC) Edinburgh, London",
        },
        {
          value: "British Summer Time",
          abbr: "BST",
          text: "(UTC+01:00) Edinburgh, London",
        },
        {
          value: "GMT Standard Time",
          abbr: "GDT",
          text: "(UTC) Dublin, Lisbon",
        },
        {
          value: "Greenwich Standard Time",
          abbr: "GST",
          text: "(UTC) Monrovia, Reykjavik",
        },
        {
          value: "W. Europe Standard Time",
          abbr: "WEDT",
          text: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
        },
        {
          value: "Central Europe Standard Time",
          abbr: "CEDT",
          text: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
        },
        {
          value: "Romance Standard Time",
          abbr: "RDT",
          text: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
        },
        {
          value: "Central European Standard Time",
          abbr: "CEDT",
          text: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
        },
        {
          value: "W. Central Africa Standard Time",
          abbr: "WCAST",
          text: "(UTC+01:00) West Central Africa",
        },
        {
          value: "Namibia Standard Time",
          abbr: "NST",
          text: "(UTC+01:00) Windhoek",
        },
        {
          value: "GTB Standard Time",
          abbr: "GDT",
          text: "(UTC+02:00) Athens, Bucharest",
        },
        {
          value: "Middle East Standard Time",
          abbr: "MEDT",
          text: "(UTC+02:00) Beirut",
        },
        {
          value: "Egypt Standard Time",
          abbr: "EST",
          text: "(UTC+02:00) Cairo",
        },
        {
          value: "Syria Standard Time",
          abbr: "SDT",
          text: "(UTC+02:00) Damascus",
        },
        {
          value: "E. Europe Standard Time",
          abbr: "EEDT",
          text: "(UTC+02:00) E. Europe",
        },
        {
          value: "South Africa Standard Time",
          abbr: "SAST",
          text: "(UTC+02:00) Harare, Pretoria",
        },
        {
          value: "FLE Standard Time",
          abbr: "FDT",
          text: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
        },
        {
          value: "Turkey Standard Time",
          abbr: "TDT",
          text: "(UTC+03:00) Istanbul",
        },
        {
          value: "Israel Standard Time",
          abbr: "JDT",
          text: "(UTC+02:00) Jerusalem",
        },
        {
          value: "Libya Standard Time",
          abbr: "LST",
          text: "(UTC+02:00) Tripoli",
        },
        {
          value: "Jordan Standard Time",
          abbr: "JST",
          text: "(UTC+03:00) Amman",
        },
        {
          value: "Arabic Standard Time",
          abbr: "AST",
          text: "(UTC+03:00) Baghdad",
        },
        {
          value: "Kaliningrad Standard Time",
          abbr: "KST",
          text: "(UTC+02:00) Kaliningrad",
        },
        {
          value: "Arab Standard Time",
          abbr: "AST",
          text: "(UTC+03:00) Kuwait, Riyadh",
        },
        {
          value: "E. Africa Standard Time",
          abbr: "EAST",
          text: "(UTC+03:00) Nairobi",
        },
        {
          value: "Moscow Standard Time",
          abbr: "MSK",
          text: "(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk",
        },
        {
          value: "Samara Time",
          abbr: "SAMT",
          text: "(UTC+04:00) Samara, Ulyanovsk, Saratov",
        },
        {
          value: "Iran Standard Time",
          abbr: "IDT",
          text: "(UTC+03:30) Tehran",
        },
        {
          value: "Arabian Standard Time",
          abbr: "AST",
          text: "(UTC+04:00) Abu Dhabi, Muscat",
        },
        {
          value: "Azerbaijan Standard Time",
          abbr: "ADT",
          text: "(UTC+04:00) Baku",
        },
        {
          value: "Mauritius Standard Time",
          abbr: "MST",
          text: "(UTC+04:00) Port Louis",
        },
        {
          value: "Georgian Standard Time",
          abbr: "GET",
          text: "(UTC+04:00) Tbilisi",
        },
        {
          value: "Caucasus Standard Time",
          abbr: "CST",
          text: "(UTC+04:00) Yerevan",
        },
        {
          value: "Afghanistan Standard Time",
          abbr: "AST",
          text: "(UTC+04:30) Kabul",
        },
        {
          value: "West Asia Standard Time",
          abbr: "WAST",
          text: "(UTC+05:00) Ashgabat, Tashkent",
        },
        {
          value: "Yekaterinburg Time",
          abbr: "YEKT",
          text: "(UTC+05:00) Yekaterinburg",
        },
        {
          value: "Pakistan Standard Time",
          abbr: "PKT",
          text: "(UTC+05:00) Islamabad, Karachi",
        },
        {
          value: "India Standard Time",
          abbr: "IST",
          text: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
        },
        {
          value: "Sri Lanka Standard Time",
          abbr: "SLST",
          text: "(UTC+05:30) Sri Jayawardenepura",
        },
        {
          value: "Nepal Standard Time",
          abbr: "NST",
          text: "(UTC+05:45) Kathmandu",
        },
        {
          value: "Central Asia Standard Time",
          abbr: "CAST",
          text: "(UTC+06:00) Nur-Sultan (Astana)",
        },
        {
          value: "Bangladesh Standard Time",
          abbr: "BST",
          text: "(UTC+06:00) Dhaka",
        },
        {
          value: "Myanmar Standard Time",
          abbr: "MST",
          text: "(UTC+06:30) Yangon (Rangoon)",
        },
        {
          value: "SE Asia Standard Time",
          abbr: "SAST",
          text: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
        },
        {
          value: "N. Central Asia Standard Time",
          abbr: "NCAST",
          text: "(UTC+07:00) Novosibirsk",
        },
        {
          value: "China Standard Time",
          abbr: "CST",
          text: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
        },
        {
          value: "North Asia Standard Time",
          abbr: "NAST",
          text: "(UTC+08:00) Krasnoyarsk",
        },
        {
          value: "Singapore Standard Time",
          abbr: "MPST",
          text: "(UTC+08:00) Kuala Lumpur, Singapore",
        },
        {
          value: "W. Australia Standard Time",
          abbr: "WAST",
          text: "(UTC+08:00) Perth",
        },
        {
          value: "Taipei Standard Time",
          abbr: "TST",
          text: "(UTC+08:00) Taipei",
        },
        {
          value: "Ulaanbaatar Standard Time",
          abbr: "UST",
          text: "(UTC+08:00) Ulaanbaatar",
        },
        {
          value: "North Asia East Standard Time",
          abbr: "NAEST",
          text: "(UTC+08:00) Irkutsk",
        },
        {
          value: "Japan Standard Time",
          abbr: "JST",
          text: "(UTC+09:00) Osaka, Sapporo, Tokyo",
        },
        {
          value: "Korea Standard Time",
          abbr: "KST",
          text: "(UTC+09:00) Seoul",
        },
        {
          value: "Cen. Australia Standard Time",
          abbr: "CAST",
          text: "(UTC+09:30) Adelaide",
        },
        {
          value: "AUS Central Standard Time",
          abbr: "ACST",
          text: "(UTC+09:30) Darwin",
        },
        {
          value: "E. Australia Standard Time",
          abbr: "EAST",
          text: "(UTC+10:00) Brisbane",
        },
        {
          value: "AUS Eastern Standard Time",
          abbr: "AEST",
          text: "(UTC+10:00) Canberra, Melbourne, Sydney",
        },
        {
          value: "West Pacific Standard Time",
          abbr: "WPST",
          text: "(UTC+10:00) Guam, Port Moresby",
        },
        {
          value: "Tasmania Standard Time",
          abbr: "TST",
          text: "(UTC+10:00) Hobart",
        },
        {
          value: "Yakutsk Standard Time",
          abbr: "YST",
          text: "(UTC+09:00) Yakutsk",
        },
        {
          value: "Central Pacific Standard Time",
          abbr: "CPST",
          text: "(UTC+11:00) Solomon Is., New Caledonia",
        },
        {
          value: "Vladivostok Standard Time",
          abbr: "VST",
          text: "(UTC+11:00) Vladivostok",
        },
        {
          value: "New Zealand Standard Time",
          abbr: "NZST",
          text: "(UTC+12:00) Auckland, Wellington",
        },
        {
          value: "UTC+12",
          abbr: "U",
          text: "(UTC+12:00) Coordinated Universal Time+12",
        },
        {
          value: "Fiji Standard Time",
          abbr: "FST",
          text: "(UTC+12:00) Fiji",
        },
        {
          value: "Magadan Standard Time",
          abbr: "MST",
          text: "(UTC+12:00) Magadan",
        },
        {
          value: "Kamchatka Standard Time",
          abbr: "KDT",
          text: "(UTC+12:00) Petropavlovsk-Kamchatsky - Old",
        },
        {
          value: "Tonga Standard Time",
          abbr: "TST",
          text: "(UTC+13:00) Nuku'alofa",
        },
        {
          value: "Samoa Standard Time",
          abbr: "SST",
          text: "(UTC+13:00) Samoa",
        },
      ],
    };
  },
  getters: appGetters,
  mutations: appMutations,
};
